import * as React from 'react';
import { Survey, SurveyVersion, SecondaryReportOrgUser, SecondaryReport } from '../../../models';
import { NotificationService, SurveyDataService, SecondaryReportDataService } from '../../../services';

interface SecondaryReportOrgUserFormProps {
    notificationService: NotificationService;
    orgId?: number;
    userId?: number;
}

interface SecondaryReportOrgUserFormState {
    surveys: Survey[];
    selectedSurveyId: number;
    selectedSurveyVersionId: number;
    selectedSecondaryReportId: number;
    secondaryReportUserOrgs: SecondaryReportOrgUser[];
}

export class SecondaryReportOrgUserForm extends React.Component<SecondaryReportOrgUserFormProps, SecondaryReportOrgUserFormState> {
    
    private secondaryReportDataService = new SecondaryReportDataService(this.props.notificationService);
    private surveyService = new SurveyDataService(this.props.notificationService);

    constructor(props: SecondaryReportOrgUserFormProps) {
        super(props);

        this.state = {
            surveys: [],
            selectedSurveyId: -1,
            selectedSurveyVersionId: -1,
            selectedSecondaryReportId: -1,
            secondaryReportUserOrgs: []
        };
    }

    componentDidMount() {

        this.surveyService.getAllForSecondaryReports(this.props.orgId).then((surveys: Survey[]) => {
            this.setState({
                surveys: surveys
            });
        });

        if (this.props.userId) {
            this.secondaryReportDataService.getAllForUser(this.props.userId).then((srou: SecondaryReportOrgUser[]) => {
                this.setState({
                    secondaryReportUserOrgs: srou
                });
            });
        } else if (this.props.orgId) {
            this.secondaryReportDataService.getAllForOrg(this.props.orgId).then((srou: SecondaryReportOrgUser[]) => {
                this.setState({
                    secondaryReportUserOrgs: srou
                });
            });
        }
    }

    render() {
        return (
            <div>
                <div>
                    <div className="row">
                        <div className="col-xs-3">
                            <label>Survey</label>
                            <select className="form-control" value={this.state.selectedSurveyId} onChange={(e: any) => this.setState({selectedSurveyId: parseInt(e.target.value, 10)})} >
                                <option value={-1}>- Select -</option>
                                {this.state.surveys.map((s: Survey) => {
                                    return <option key={`survey-${s.id}`} value={s.id}>{s.name}</option>;
                                })}
                            </select>
                        </div>
                        <div className="col-xs-3">
                            <label>Survey Version</label>
                            {(() => {
                                var s = this.survey();
                                if (!s) {
                                    return <select className="form-control" />;
                                }
                                
                                return <select className="form-control" value={this.state.selectedSurveyVersionId} onChange={(e: any) => this.setState({selectedSurveyVersionId: parseInt(e.target.value, 10)})} >
                                    <option value={-1}>- Select -</option>
                                    {s.surveyVersions.map((sv: SurveyVersion) => {
                                        return <option key={`survey-version-${sv.id}`} value={sv.id}>{sv.nickname}</option>;
                                    })}
                                </select>;
                            })()}
                        </div>
                        <div className="col-xs-3">
                            <label>Secondary Report</label>
                            {(() => {
                                var s = this.survey();
                                var sv = this.surveyVersion();
                                
                                if (!s || !sv) {
                                    return <select className="form-control" />;
                                }
                                
                                return <select className="form-control" value={this.state.selectedSecondaryReportId} onChange={(e: any) => this.setState({selectedSecondaryReportId: parseInt(e.target.value, 10)})} >
                                    <option value={-1}>- Select -</option>
                                    {sv.secondaryReports.map((sr: SecondaryReport) => {
                                        return <option key={`survey-report-${sr.id}`} value={sr.id}>{sr.name}</option>;
                                    })}
                                </select>;
                            })()}
                        </div>
                        <div className="col-xs-3">
                            <label>Action</label>
                            <br />
                            <a className="btn btn-default btn-block" onClick={(e: any) => this.addSecondaryReport(this.secondaryReport())}>Add</a>
                        </div>
                    </div>
                </div>
                <div>
                    <label>Secondary Reports Access</label>
                    {this.state.secondaryReportUserOrgs.map((sruo: SecondaryReportOrgUser, sruoInd: number) => {
                        return <div className="row" key={`sruo-${sruoInd}`}>
                            <div className="col-xs-3">
                                <span>{sruo.secondaryReport && sruo.secondaryReport.surveyVersion.survey.name}</span>
                            </div>
                            <div className="col-xs-3">
                                <span>{sruo.secondaryReport && sruo.secondaryReport.surveyVersion.nickname}</span>
                            </div>
                            <div className="col-xs-3">
                                <span>{sruo.secondaryReport && sruo.secondaryReport.name}</span>
                            </div>
                            <div className="col-xs-3">
                                <a className="btn btn-danger" onClick={(e: any) => this.removeOrgUser(sruo.id)}>Remove</a>
                            </div>
                        </div>;
                    })}
                </div>
            </div>);
    }

    private survey() {
        if (this.state.selectedSurveyId === - 1) {
            return undefined;
        }

        return this.state.surveys.find((s2: Survey) => {
            return s2.id === this.state.selectedSurveyId;
        });
    }

    private surveyVersion() {
        if (this.state.selectedSurveyId === - 1 || this.state.selectedSurveyVersionId === - 1) {
            return undefined;
        }

        var s = this.state.surveys.find((s2: Survey) => {
            return s2.id === this.state.selectedSurveyId;
        });

        if (!s) {
            return undefined;
        }

        return s.surveyVersions.find((sv2: SurveyVersion) => {
            return sv2.id === this.state.selectedSurveyVersionId;
        });
    }

    private secondaryReport() {
        if (this.state.selectedSurveyId === - 1 || this.state.selectedSurveyVersionId === - 1 || this.state.selectedSecondaryReportId === - 1) {
            return undefined;
        }

        var s = this.state.surveys.find((s2: Survey) => {
            return s2.id === this.state.selectedSurveyId;
        });

        if (!s) {
            return undefined;
        }

        var sv = s.surveyVersions.find((sv2: SurveyVersion) => {
            return sv2.id === this.state.selectedSurveyVersionId;
        });

        if (!sv) {
            return undefined;
        }

        return sv.secondaryReports.find((sr2: SecondaryReport) => {
            return sr2.id === this.state.selectedSecondaryReportId;
        });
    }

    private addSecondaryReport(sr: SecondaryReport | undefined) {
        if (!sr) {
            return;
        }
        var sruo = this.state.secondaryReportUserOrgs;
        
        var sv = this.surveyVersion();
        if (sv) {
            sr.surveyVersion = sv;
            var s = this.survey();
            if (s) {
                sr.surveyVersion.survey = s;
            }
        }
        var o: SecondaryReportOrgUser = {
            id: 0,
            organizationID: this.props.orgId,
            userID: this.props.userId,
            secondaryReportID: this.state.selectedSecondaryReportId,
            allAccess: false
        };
        this.secondaryReportDataService.createOrgUser(o).then((r: SecondaryReportOrgUser) => {
            sruo.push(r);
            this.setState({
                secondaryReportUserOrgs: sruo
            });
        });
    }

    private removeOrgUser(id: number) {
        this.secondaryReportDataService.deleteOrgUser(id).then(() => {
            this.setState({
                secondaryReportUserOrgs: this.state.secondaryReportUserOrgs.filter((sruo: SecondaryReportOrgUser) => {
                    return sruo.id !== id;
                })
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/SecondaryReportOrgUserForm.tsx